import React, { useState, useEffect } from "react";
import ApiService from "../../../Services/user/service";
import Table from "../../../Utils/Table/Table1";
import { fDateTimesec} from "../../../Utils/Date_format/datefromat";
import Header from "../../../components/Dashboard/Header";
import { MdOutlineMenuBook } from "react-icons/md";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import exportToExcel from "../../../Utils/Exportfile";
const LedgerReport = () => {

 const exportHeaders = [
  { label: "Symbol", key: "symbol" },
  { label: "Type", key: "type" },
  { label: "Balance", key: "Amount" },
  { label: "Brokerage", key: "brokerage" },
  { label: "Balance before Order", key: "wallet_balance" },
  { label: "Date", key: "createdAt" },
  { label: "Message", key: "message" },
];


  const user_id = localStorage.getItem("user_id");
const currency = localStorage.getItem("currentCurrency");
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("1w");  
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  // Currency → INR / USD
  const Market_Type = localStorage.getItem("currentCurrency") ?? "1";
  const currencyType = Market_Type === "1" ? "INR" : "USD";
  // 🔥 FINAL API FUNCTION (Correct Payload)
  const getLedger = async () => {
    if (!user_id) return;

    try {
      setLoading(true);

      const body = {
        userid: user_id,
        filter: filter,              // 1w / 1m / 6m / 1y / all
        type: currencyType,          // Only INR or USD
        page: page,
        limit: rowsPerPage,
      };

      const res = await ApiService.ledgerReport(body);
      console.log("Ledger Response:", res.data);

      setData(res?.data?.data || []);
      setTotalPages(res?.data?.pagination?.totalPages || 1);
      setTotalCount(res?.data?.pagination?.totalRecords || 0);

    } catch (err) {
      console.log("Ledger Error:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Pagination Change
  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    setPage(newPage);
  };

  // Rows per page Change
  const handleRowsPerPageChange = (newLimit) => {
    setRowsPerPage(newLimit);
    setPage(1);
  };

  // Auto-fetch when filter, page, rows change
  useEffect(() => {
    getLedger();
  }, [filter, page, rowsPerPage]);

   const columns = [

//   {
//   Header: "S.No",
//   Cell: ({ row }) => Number(row.id) + 1,
// },

     {
      Header:"Symbol", accessor: "symbol",
      Cell:({row}) => 
        row.symbol ? row.symbol : "-"
    },
 
    // {
    //   Header: "Type",
    //   accessor: "type",
    //   Cell: ({ row }) => (
    //     <span
    //       style={{
    //         textTransform: "capitalize",
    //         color: row.value === "credit" ? "green" : "red",
    //         fontWeight: 600,
    //       }}
    //     >
    //       {row.type || "-"}
    //     </span>
    //   ),
    // },
    {
  Header: "Type",
  accessor: "type",
  Cell: ({ row }) => {
    const isCredit = row?.type.toLowerCase() === "credit";

    return (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          justifyContent: "center",
          textTransform: "capitalize",
          color: isCredit ? "green" : "red",
          fontWeight: 600,
        }}
      >
        {isCredit ? <FaArrowUp /> : <FaArrowDown />}
        {row.type || "-"}
      </span>
    );
  },
}
,
    {
  Header: "Balance",
  accessor: "Amount",
  Cell: ({ row }) =>
    row.Amount ? (
      <span
        style={{
          color: Number(row.Amount) >= 0 ? "green" : "red",
          fontWeight: 600,
        }}
      >
        {currency === "1" ? "₹" : "$"} {Number(row.Amount).toFixed(2)}
      </span>
    ) : "-",
},



    {
      Header:"Brokerage",
      accessor: "brokerage",
      Cell: ({ row }) =>
        row.brokerage ?  `${currency === "1" ? "₹" : "$"} ${Number(row.brokerage).toFixed(2)}` : "-",
    },
    {
      Header:"Balance before Order",
      accessor: "wallet_balance",
      Cell: ({ row }) =>
        row.wallet_balance ? `${currency === "1" ? "₹" : "$"} ${Number(row.wallet_balance).toFixed(3)}` : "-",
    },

    {
  Header: "Date",
  accessor: "createdAt",
  Cell: ({ row }) => {
    const date = row.createdAt;
    return date ? fDateTimesec(date) : "--";
  },
},
      {
      Header: "Message",
      accessor: "message",
   
    },
  ];
  return (
    <div className="container-fluid">
      <div className="card">

        {/* HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title m-0"><MdOutlineMenuBook size={28} /> Ledger Report</h4>
          

          <div className="d-flex gap-2">
            {/* FILTER DROPDOWN */}
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="form-select form-select-sm"
              style={{ width: 150 }}
            >
              <option value="1w">Last 1 Week</option>
              <option value="1m">Last 1 Month</option>
              <option value="6m">Last 6 Months</option>
              <option value="1y">Last 1 Year</option>
            </select>

               <button
                className="btn btn-success"
                onClick={() =>
                  exportToExcel( data, exportHeaders, "Ledger Report")
                }
              >
                Export Excel
              </button>
          </div>
          
           
        </div>

        {/* TABLE */}
        <Table
          columns={columns}
          data={data}
          loading={loading}
          page={page}
          totalPages={totalPages}
          totalCount={totalCount}
          initialRowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />

      </div>
    </div>
  );
};

export default LedgerReport;
